module.exports = __webpack_public_path__ + "img/190.57face1c.svg";